"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTItle = exports.StyledStrengthWrap = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _color, _templateObject6, _templateObject7;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var color = (_color = {}, (0, _defineProperty2["default"])(_color, 'very-weak', (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n  "])), function (props) {
  return (0, _utils.getPalette)('secondary', 'c03')(props);
})), (0, _defineProperty2["default"])(_color, "weak", (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n  "])), function (props) {
  return (0, _utils.getPalette)('secondary', 'c03')(props);
})), (0, _defineProperty2["default"])(_color, "average", (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n  "])), function (props) {
  return (0, _utils.getPalette)('warning', 'c03')(props);
})), (0, _defineProperty2["default"])(_color, "strong", (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n  "])), function (props) {
  return (0, _utils.getPalette)('success', 'c03')(props);
})), (0, _defineProperty2["default"])(_color, 'very-strong', (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n  "])), function (props) {
  return (0, _utils.getPalette)('success', 'c03')(props);
})), _color);

var StyledStrengthWrap = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  .eui-item-wrap {\n    display: flex;\n    position: relative;\n    height: 4px;\n    background-color: ", ";\n    border-radius: ", "px;\n\n    .eui-item {\n      flex: 1;\n      border-radius: ", "px;\n      margin-right: 2px;\n      &.active {\n        background-color: ", ";\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n  ", "\n  ", "\n"])), function (props) {
  return (0, _utils.getPalette)('base', 'c00')(props);
}, function (props) {
  return props.radius;
}, function (props) {
  return props.radius;
}, function (props) {
  return color[props.color];
}, _styledSystem.space, _styledSystem.width);

exports.StyledStrengthWrap = StyledStrengthWrap;

var StyledTItle = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  padding-bottom: 5px;\n  ", "\n\n  .label {\n    ", "\n  }\n\n  .level-string {\n    color: ", ";\n    font-family: inherit;\n  }\n"])), function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getTypography)('helperText')(props);
}, function (props) {
  return color[props.color];
});

exports.StyledTItle = StyledTItle;